import { z } from 'zod';
/**
 * Stable, machine-readable error codes. The frontend maps a code to a
 * translated message; it never parses the human-readable `message`.
 * Add codes, never repurpose them.
 */
export const ERROR_CODES = [
    'VALIDATION_FAILED',
    'PHONE_TAKEN',
    'DOCUMENT_TAKEN',
    'CATEGORY_IN_USE',
    'USERNAME_TAKEN',
    'NO_PLATFORM_ACCESS',
    'UA_UNAVAILABLE',
    'INTEGRATION_UNAUTHORIZED',
    'UNAUTHENTICATED',
    'INVALID_CREDENTIALS',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'UNIQUE_VIOLATION',
    'FOREIGN_KEY_VIOLATION',
    'RATE_LIMITED',
    'IDEMPOTENCY_KEY_REUSED',
    'MOVEMENT_REFERENCE_CONFLICT',
    'REQUEST_IN_PROGRESS',
    'PAYLOAD_TOO_LARGE',
    'UNPROCESSABLE',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
    // The phone rule (customers.md section 9.3).
    'PHONE_REQUIRED',
    'PHONE_INVALID',
    'PHONE_NOT_MOBILE',
    'PHONE_COUNTRY_NOT_ALLOWED',
    // WhatsApp phone verification (customers.md section 10).
    'PHONE_VERIFICATION_REQUIRED',
    'PHONE_VERIFICATION_INVALID',
    'PHONE_VERIFICATION_RECEIPT_EXPIRED',
    'OTP_INVALID',
    'OTP_EXPIRED',
    'OTP_ATTEMPTS_EXCEEDED',
    'OTP_RESEND_TOO_SOON',
    'OTP_SEND_LIMIT',
    'OTP_SEND_FAILED',
    'OTP_ALREADY_VERIFIED',
    'OTP_ALREADY_CONSUMED',
    'OTP_BINDING_MISMATCH',
    'OTP_NOT_VERIFIED',
    'OTP_CONSUME_WINDOW_PASSED',
    'IDEMPOTENCY_CONFLICT',
];
export const errorCodeSchema = z.enum(ERROR_CODES);
export const fieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
    code: z.string().optional(),
});
//# sourceMappingURL=api-error.js.map